import styled from "styled-components";
import { BaseFlex } from "../../../components/flex/styled";
import { useContext } from "react";
import { Context } from "../../../context";

export const NavbarWrapper = styled(BaseFlex)(() => {
  return {
    alignItems: "center",
    justifyContent: "space-between",
    margin: "calc(var(--sectionMargin)) var(--pagePadding)",
    gap: "var(--flexGap)",
    "& .hamburger-icon": {
      overflow: "hidden",
    },
    "@media screen and (max-width: 1024px)": {
      "& .logo-box-area": {
        maxWidth: "50%",
        "& svg": {
          width: "100%",
        },
      },
    },
    "@media screen and (min-width: 1025px)": {
      "& .hamburger-icon": {
        display: "none",
      },
    },
  };
});

export const NavLinksWrapper = styled(BaseFlex)(() => {
  const { isMenuOpen } = useContext(Context);
  return {
    justifyContent: "center",
    flex: "1",
    "& a": {
      textDecoration: "none",
      color: "var(--color-text)",
      ":hover": {
        color: "var(--color-primary)",
      },
    },
    "& .mobile-buttons": {
      display: "none",
    },
    "@media screen and (max-width: 1024px)": {
      display: isMenuOpen ? "flex" : "none",
      flexDirection: "column",
      position: "absolute",
      top: "var(--navHeight)",
      left: "var(--pagePadding)",
      right: "var(--pagePadding)",
      overflow: "hidden",
      zIndex: 1,
      flex: "unset",
      "& span": {
        display: "block",
      },
      "& .mobile-buttons": {
        display: "flex",
        flexDirection: "column",
        gap: "calc(var(--flexGap)/2)",
        marginTop: "calc(var(--flexGap)/2)",
        paddingTop: "calc(var(--flexGap)/2)",
        borderTop: "1px solid #e0e0e0",
        "& button": {
          width: "100%",
        },
      },
    },
  };
});

export const NavButtonsContainer = styled(BaseFlex)(() => {
  return {
    gap: "calc(var(--flexGap)/2)",
    alignItems: "center",
    "& button": {
      fontSize: "1rem",
      padding: "calc(var(--cardPadding)/3) calc(var(--cardPadding)/1.5)",
      border: "2px solid transparent",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
    },
    "& .login-button": {
      "&:hover": {
        border: "2px solid var(--color-primary)",
      },
    },
    "@media screen and (max-width: 1024px)": {
      display: "none",
    },
  };
});
